<template>
    <div>
        <navbar></navbar>
        <section >
  <div class="container">
    <h1 class="title">
      Thanks for Your Order!
    </h1>
    <h2 class="subtitle">
    <b-button type="is-success" @click="moveAlong()" >View Orders</b-button>

    </h2>
<p>



</p>


  </div>
</section>

    </div>
</template>

<script>
import Navbar from "./features/Navbar"
import SampleReports from "./SampleReports"
import BuyReports from "./BuyReports"
import { ORDER_ADD,ORDER_RESTAPI } from "../store/actions/order";

export default {
    name: 'Dashboard',
    data() {
        return {
			search: '',
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
        SampleReports
    },
    mounted() {
  this.$store.commit(ORDER_RESTAPI, this.$api.REST_API)
    this.$store.dispatch(ORDER_ADD  ).then(() => {
    //  this.$router.push("/oops");

      //	this.$router.push('/dashboard')
      });
      },
    methods: {
        fetchBooks() {
        },
        signUp() {
        this.$router.push({ name: "Register" });

        },
        goSampleReports() {
        this.$router.push({ name: "SampleReports" });

        },
        moveAlong() {
        this.$router.push({ name: "Orders" });

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderConfirmation.vue